var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.toggle($event)}}},[_c('span',{class:[
			'zov-switch-slot',
			_vm.currentValue ? 'zov-switch-slot-open' : 'zov-switch-slot-close'
		]},[(_vm.currentValue)?_vm._t("open"):_vm._e(),(!_vm.currentValue)?_vm._t("close"):_vm._e()],2),_c('div',{staticClass:"zov-switch-inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }